import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isLoggedInSelector } from "../../../store/authSlice";
import { ROUTES } from "../../../utils/constants";

/**
 * @desc Navigate back to login screen, if necessary.
 */
export const useAdminLogin = () => {
  // CONSTANTS ----------------------------------------------------------------

  const navigate = useNavigate();
  const isLoggedIn = useSelector(isLoggedInSelector);

  // SIDE EFFECTS -------------------------------------------------------------

  /**
   * @desc Navigate to login if not logged in.
   */
  useEffect(() => {
    if (!isLoggedIn) {
      navigate(ROUTES.LOGIN);
    }
  }, [isLoggedIn, navigate]);

  // HOOK STATE ---------------------------------------------------------------

  return {
    isLoggedIn,
  };
};
